import { render, staticRenderFns } from "./ElRemotePick.vue?vue&type=template&id=bfbfd8ec"
import script from "./ElRemotePick.vue?vue&type=script&lang=js"
export * from "./ElRemotePick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports